import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import StoreRequest from "../../models/store-requests";

interface StoreRequestDeleteModalProps {
  show: boolean;
  storeRequest?: StoreRequest;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const StoreRequestDeleteModal: React.FC<StoreRequestDeleteModalProps> = ({
  show,
  storeRequest,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = storeRequest
    ? `Está seguro de que quiere eliminar el pedido: ${storeRequest.variantName}`
    : "";

  const onDeleteClick = async () => {
    if (storeRequest !== undefined) {
      setSubmitting(true);
      const colorStatus = await deleteItem<StoreRequest>(
        `/store_requests/${storeRequest.id}/`,
        storeRequest
      );

      if (colorStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (colorStatus.detail !== undefined) {
          message = colorStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default StoreRequestDeleteModal;
